import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';

const days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
const shortDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
const months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];

@Injectable({ providedIn: 'root' })
export class PrimeLocaleService {
  constructor(translate: TranslateService, prime: PrimeNG) {
    // DatePicker now reads locale from PrimeNG rather than a per-control input.
    translate.stream([...days, ...shortDays, ...months, 'TODAY', 'CLEAR'])
      .pipe(takeUntilDestroyed())
      .subscribe(labels => prime.setTranslation({
        firstDayOfWeek: 0,
        dayNames: days.map(key => labels[key]),
        dayNamesShort: shortDays.map(key => labels[key]),
        dayNamesMin: shortDays.map(key => labels[key].slice(0, 2)),
        monthNames: months.map(key => labels[key]),
        monthNamesShort: months.map(key => labels[key].slice(0, 3)),
        today: labels['TODAY'],
        clear: labels['CLEAR'],
      }));
  }
}
